import KeyValue from "components/KeyValue";
import { Spinner } from "components/Spinner";
import { Trash } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import IconEmphasized from "ds/components/IconEmphasized";
import { AwsIntegrationIntentProjectAttachment } from "types/generated";
import { CLOUD_INTEGRATION_CONFIG } from "shared/CloudIntegration/constants";
import { getDuration } from "utils/time";
import Card from "ds/components/Card";

import SwitchIcon from "../Details/SwitchIcon";

const cloudConfig = CLOUD_INTEGRATION_CONFIG.AWS;

type AttachCloudDetailsCardProps = {
  attachedIntegration: AwsIntegrationIntentProjectAttachment;
  className?: string;
  readOnly?: boolean;
  onDetach?: () => void;
  detachLoading?: boolean;
};

const IntentProjectDetailsCard = ({
  attachedIntegration,
  className,
  readOnly,
  onDetach,
  detachLoading,
}: AttachCloudDetailsCardProps) => {
  return (
    <Card
      headerPrefix={<IconEmphasized icon={cloudConfig.logo} />}
      title={attachedIntegration.awsIntegration.name}
      headerSuffix={
        <ButtonIcon
          disabled={detachLoading || readOnly}
          forceTooltip={readOnly}
          icon={detachLoading ? Spinner : Trash}
          onPress={onDetach}
          variant={detachLoading ? "ghost" : "ghostDanger"}
        >
          {readOnly ? "You don't have permission to detach this integration" : "Detach"}
        </ButtonIcon>
      }
      className={className}
    >
      <KeyValue name="Region">{attachedIntegration.awsRegion}</KeyValue>
      <KeyValue name="Role ARN">{attachedIntegration.awsIntegration.roleArn}</KeyValue>
      <KeyValue name="Duration">
        {getDuration(attachedIntegration.awsIntegration.durationSeconds)}
      </KeyValue>
      <KeyValue name="External Id">{attachedIntegration.awsIntegration.externalId}</KeyValue>

      {"read" in attachedIntegration && "write" in attachedIntegration && (
        <>
          <KeyValue align="center" name="Read">
            <SwitchIcon checked={attachedIntegration.read} />
          </KeyValue>
          <KeyValue align="center" name="Write">
            <SwitchIcon checked={attachedIntegration.write} />
          </KeyValue>
        </>
      )}
    </Card>
  );
};

export default IntentProjectDetailsCard;
